<template>
  <div class="nodata_box">
    <img :src="img" alt="" class="icon" />
    <p>什么也没有</p>
  </div>
</template>
<script>
export default {
  data() {
    return {
      img: require("@/assets/png/nodata.png"),
    };
  },
};
</script>
<style scoped lang="scss">
.nodata_box {
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  .icon {
    width: 228px;
    margin-top: 200px;
  }
  p {
    margin-top: 36px;
    text-align: center;
    color: rgba(0, 0, 0, 0.35);
    font-size: 14px;
  }
}
</style>
